// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vd_O","badges":"styles_badges__3jddr"};